<template>
  <div class="main">
    <van-tabs v-model="active" color="#3B87F5" sticky background="#fff" animated title-active-color="#3B87F5" @click="getBookingList">
      <van-tab title="全部" name="全部">
        <div class="bomCont">
          <ul v-if="bookingList&&bookingList.length>0">
            <li v-for="(item,index) in bookingList" :key="index" @click="changetDetail(item.boOrderType,item.id)">
              <div class="contTop">
                <div class="conttopLeft">{{item.cCanteenName}}</div>
                <div :class="item.boOrderType=='待就餐'?'contStatusActive contStatus':'contStatus'">{{item.boOrderType}}</div>
              </div>
              <div class="contBom">
                <div class="bomLine">
                  <div class="bomLineLeft">预定人姓名：</div>
                  <div class="bomLineRight">{{item.boBookingPerson}}</div>
                </div>
                <div class="bomLine">
                  <div class="bomLineLeft">预定人数：</div>
                  <div class="bomLineRight">{{item.boNumber}}</div>
                </div>
                <div class="bomLine">
                  <div class="bomLineLeft">预定时间：</div>
                  <div class="bomLineRight">{{item.boAppointment}}</div>
                </div>
                <div class="bomLine" v-if="item.boOrderType=='待就餐'" style="justify-content: flex-end;">
                  <div class="cancelBtn" @click.stop="channelFunc(item.id)">取消预约</div>
                </div>
                <div class="bomLine" v-if="item.boOrderType=='待评价'" style="justify-content: flex-end;">
                  <div class="pinglunBtn" @click.stop="changeToPath(item.boCanteenID,item.id)">评价</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-else style="margin:60px auto 0;text-align:center;">暂无数据</div>
        </div>
      </van-tab>
      <van-tab title="待就餐" name="待就餐">
        <div class="bomCont">
          <ul v-if="bookingList&&bookingList.length>0">
            <li v-for="(item,index) in bookingList" :key="index" @click="changetDetail(item.boOrderType,item.id)">
              <div class="contTop">
                <div class="conttopLeft">{{item.cCanteenName}}</div>
                <div :class="item.boOrderType=='待就餐'?'contStatusActive contStatus':'contStatus'">{{item.boOrderType}}</div>
              </div>
              <div class="contBom">
                <div class="bomLine">
                  <div class="bomLineLeft">预定人姓名：</div>
                  <div class="bomLineRight">{{item.boBookingPerson}}</div>
                </div>
                <div class="bomLine">
                  <div class="bomLineLeft">预定人数：</div>
                  <div class="bomLineRight">{{item.boNumber}}</div>
                </div>
                <div class="bomLine">
                  <div class="bomLineLeft">预定时间：</div>
                  <div class="bomLineRight">{{item.boAppointment}}</div>
                </div>
                <div class="bomLine" v-if="item.boOrderType=='待就餐'" style="justify-content: flex-end;">
                  <div class="cancelBtn" @click.stop="channelFunc(item.id)">取消预约</div>
                </div>
                <div class="bomLine" v-if="item.boOrderType=='待评价'" style="justify-content: flex-end;">
                  <div class="pinglunBtn" @click.stop="changeToPath(item.boCanteenID,item.id)">评价</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-else style="margin:60px auto 0;text-align:center;">暂无数据</div>
        </div>
      </van-tab>
      <van-tab title="已就餐" name="已就餐">
        <div class="bomCont">
          <ul v-if="bookingList&&bookingList.length>0">
            <li v-for="(item,index) in bookingList" :key="index" @click="changetDetail(item.boOrderType,item.id)">
              <div class="contTop">
                <div class="conttopLeft">{{item.cCanteenName}}</div>
                <div :class="item.boOrderType=='待就餐'?'contStatusActive contStatus':'contStatus'">{{item.boOrderType}}</div>
              </div>
              <div class="contBom">
                <div class="bomLine">
                  <div class="bomLineLeft">预定人姓名：</div>
                  <div class="bomLineRight">{{item.boBookingPerson}}</div>
                </div>
                <div class="bomLine">
                  <div class="bomLineLeft">预定人数：</div>
                  <div class="bomLineRight">{{item.boNumber}}</div>
                </div>
                <div class="bomLine">
                  <div class="bomLineLeft">预定时间：</div>
                  <div class="bomLineRight">{{item.boAppointment}}</div>
                </div>
                <div class="bomLine" v-if="item.boOrderType=='待就餐'" style="justify-content: flex-end;">
                  <div class="cancelBtn" @click.stop="channelFunc(item.id)">取消预约</div>
                </div>
                <div class="bomLine" v-if="item.boOrderType=='待评价'" style="justify-content: flex-end;">
                  <div class="pinglunBtn" @click.stop="changeToPath(item.boCanteenID,item.id)">评价</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-else style="margin:60px auto 0;text-align:center;">暂无数据</div>
        </div>
      </van-tab>
      <van-tab title="待评价" name="待评价">
        <div class="bomCont">
          <ul v-if="bookingList&&bookingList.length>0">
            <li v-for="(item,index) in bookingList" :key="index" @click="changetDetail(item.boOrderType,item.id)">
              <div class="contTop">
                <div class="conttopLeft">{{item.cCanteenName}}</div>
                <div :class="item.boOrderType=='待就餐'?'contStatusActive contStatus':'contStatus'">{{item.boOrderType}}</div>
              </div>
              <div class="contBom">
                <div class="bomLine">
                  <div class="bomLineLeft">预定人姓名：</div>
                  <div class="bomLineRight">{{item.boBookingPerson}}</div>
                </div>
                <div class="bomLine">
                  <div class="bomLineLeft">预定人数：</div>
                  <div class="bomLineRight">{{item.boNumber}}</div>
                </div>
                <div class="bomLine">
                  <div class="bomLineLeft">预定时间：</div>
                  <div class="bomLineRight">{{item.boAppointment}}</div>
                </div>
                <div class="bomLine" v-if="item.boOrderType=='已预约'" style="justify-content: flex-end;">
                  <div class="cancelBtn">取消预约</div>
                </div>
                <div class="bomLine" v-if="item.boOrderType=='待评价'" style="justify-content: flex-end;">
                  <div class="pinglunBtn" @click.stop="changeToPath(item.boCanteenID,item.id)">评价</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-else style="margin:60px auto 0;text-align:center;">暂无数据</div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import qs from "qs";
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { addBaseAplus } from '../utils/zzdmd.js'
// 全局注册
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: 'appoint',
  data () {
    return {
      active:'全部',
      bookingList:[]
    }
  },
  created(){
    this.getBookingList()
  },
   mounted(){
    addBaseAplus(this.$route)
  },
  activated(){
    this.getBookingList()
  },
  methods:{
    getBookingList(){
      let param = {
        WorkerID:JSON.parse(sessionStorage.getItem('userData')).workerID,
        // WorkerID:11,
        OrderType:this.active
      }
       this.$post('api/Order/GetBookingOrder', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.bookingList = res.data
        }
      })
    },
    channelFunc(id){
      Dialog.confirm({
        title: '提示',
        message: '确认取消预约吗？',
        confirmButtonColor:'#3B87F5',
      }).then(() => {
          // on confirm
        let param = {
          BookingOrderID:id-0
        }
        this.$post('api/Order/CancelOrder', qs.stringify(param),{
          headers:{
              'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          if(res.code==1000){
            Toast({
            message: '取消成功',
            position: 'bottom',
            })
            this.getBookingList()
          }else{
            Toast({
            message: res.msg||res.message,
            position: 'bottom',
            })
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    changeToPath(id,oid){
      this.$router.push({path:'/comment',query:{id:id,oid:oid}})
    },
    changetDetail(type,id){
      this.$router.push({path:'/appointDetail',query:{type:type,id:id}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  background: #f2f2f2;
  min-height: 100vh;
  position: relative;
}
.bomCont{
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
}
/* .bomCont>ul{
  background: #fff;
  
} */
.bomCont>ul>li{
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 10px;
}
.contTop{
  width: 100%;
  box-sizing: border-box;
  padding: 12px 13px;
  border-bottom: 1px solid #E6E6E6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.conttopLeft{
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.contStatus{
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
.contStatusActive{
  color: #3B87F5 !important;
}
.contBom{
  box-sizing: border-box;
  padding: 15px 13px;
}
.bomLine{
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.bomLine:last-child{
  margin-bottom: 0;
}
.bomLineLeft{
  color: #999999;
  font-size: 14px;
  font-weight: 500;
}
.bomLineRight{
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  margin-left: 6px;
}
.cancelBtn{
  box-sizing: border-box;
  width: 90px;
  height: 28px;
  color: #3B87F5;
  border: 1px solid #3B87F5;
  border-radius: 14px;
  line-height: 28px;
  text-align: center;
}
.pinglunBtn{
  box-sizing: border-box;
  width: 90px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  color: #999999;
  border: 1px solid #999999;
  border-radius: 14px;
}
</style>



// WEBPACK FOOTER //
// src/page/appoint.vue